var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex justify-content-center p-4"},[_c('card',{staticClass:"col-sm-8 col-xl-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center mb-4"},[_c('h4',[_vm._v("Logout")])])])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }